import React from 'react';
import {Button,TextButton} from './Input';
import PropTypes from 'prop-types';


export default class Popup extends React.Component{

    onCancel=()=>{
        if(this.props.content.addCancel){
            this.props.content.addCancel();
        }
        this.props.content.cancel();
    }

    onConfirm=()=>{
        this.props.content.confirm();
        this.props.content.cancel();
    }

    render=()=>{
        const content=this.props.content;
        return (
            <div className="popup-container">
                <div className="popup-align"/>
                <div className="popup-content">
                    <h2 className="popup-title" style={{margin:"0"}}>{content.title}</h2>
                    {
                        (content.description)
                            ?
                            <div className="popup-description">{content.description}</div>
                            :
                            ""
                    }
                    <div className="popup-buttons">
                        <Button type="medium" onClick={this.onConfirm}>Confirm</Button>
                        <Button type="medium" onClick={this.onCancel}>Cancel</Button>
                    </div>
                </div>
            </div>
        )
    }
}
Popup.propTypes={
    content:PropTypes.shape({
        confirm:PropTypes.func.isRequired,
        cancel:PropTypes.func.isRequired,
        addCancel:PropTypes.func,
        title:PropTypes.string.isRequired,
        description:PropTypes.string,
    })
};
